import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ced57c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pick-the-operator__equation" }
const _hoisted_2 = { class: "pick-the-operator__points-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_countdown_bar = _resolveComponent("countdown-bar")!
  const _component_game_info_point = _resolveComponent("game-info-point")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Pick The Operator",
    name: "PickTheOperator",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    points: _ctx.gamePoints,
    "action-buttons": _ctx.actionButtons,
    onCommitOperator: _ctx.commitOperator,
    onPrecountdownOver: _ctx.start,
    onRestart: _ctx.restart
  }, {
    top: _withCtx(() => [
      _createVNode(_component_countdown_bar, {
        class: "pick-the-operator__countdown",
        countdown: _ctx.gameCountdown
      }, null, 8, ["countdown"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.gameEquation.getWithoutOperator(0)), 1)
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
          return (_openBlock(), _createBlock(_component_game_info_point, {
            key: result.id,
            value: result.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(result.info), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "points", "action-buttons", "onCommitOperator", "onPrecountdownOver", "onRestart"]))
}